import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { ApphomelayoutComponent } from '../modules/core/layouts/apphomelayout/apphomelayout.component';
import { AuthlayoutComponent } from '../modules/core/layouts/authlayout/authlayout.component';
import { ForgetpasswordComponent } from '../modules/core/pages/forgetpassword/forgetpassword.component';
import { PagenotauthorizedComponent } from '../modules/core/pages/pagenotauthorized/pagenotauthorized.component';
import { PagenotfoundComponent } from '../modules/core/pages/pagenotfound/pagenotfound.component';
import { ProfileEditComponent } from '../modules/core/pages/profile-edit/profile-edit.component';
import { ProfileComponent } from '../modules/core/pages/profile/profile.component';
import { ResetpasswordComponent } from '../modules/core/pages/resetpassword/resetpassword.component';
import { SigninComponent } from '../modules/core/pages/signin/signin.component';
import { TenantsCreatePageComponent } from '../modules/core/pages/tenants-create-page/tenants-create-page.component';
import { TenantsPageComponent } from '../modules/core/pages/tenants-page/tenants-page.component';
import { UsersCreatePageComponent } from '../modules/core/pages/users-create-page/users-create-page.component';
import { UsersListPageComponent } from '../modules/core/pages/users-list-page/users-list-page.component';
import { HomepageComponent } from '../modules/core/pages/homepage/homepage.component';
import { Office365authComponent } from '../modules/core/components/office365auth/office365auth.component';
import { UserRoles } from '../state/auth.repository';
import { DocumenttypePageComponent } from '../modules/core/pages/documenttype-page/documenttype-page.component';
import { DocumenttypePostComponent } from '../modules/core/components/documenttype-post/documenttype-post.component';
import { DocumentEditpageComponent } from '../modules/core/pages/document-editpage/document-editpage.component';
import { DocumenttypeEditpageComponent } from '../modules/core/pages/documenttype-editpage/documenttype-editpage.component';
import { DocumentPostComponent } from '../modules/core/components/document-post/document-post.component';
import { AdminDocumentPageComponent } from '../modules/core/pages/admin-document-page/admin-document-page.component';
import { DocumenttypeFromSideMenuComponent } from '../modules/core/components/documenttype-from-SideMenu/documenttype-from-SideMenu.component';
import { AdminCompaniesPageComponent } from '../modules/core/pages/admin-companies-page/admin-companies-page.component';
import { TenantFeatures } from '../state/feature.repository';
import { ClientsCreatePageComponent } from '../modules/core/pages/clients-create-page/clients-create-page.component';
import { AdminLocationsPageComponent } from '../modules/core/pages/admin-locations-page/admin-locations-page.component';
import { AdminContactsPageComponent } from '../modules/core/pages/admin-contacts-page/admin-contacts-page.component';
import { ContactsCreatePageComponent } from '../modules/core/pages/contacts-create-page/contacts-create-page.component';
import { ActiveTenantPageComponent } from '../modules/core/pages/active-tenant-page/active-tenant-page.component';
import { NotificationsListComponent } from 'app/modules/core/pages/notifications-list/notifications-list.component';
import { TenantInfoPageComponent } from 'app/modules/core/pages/tenant-info-page/tenant-info-page.component';
import { TenantEdithtmlPageComponent } from 'app/modules/core/pages/tenant-edithtml-page/tenant-edithtml-page.component';
import { TenantMsGraphEditPageComponent } from 'app/modules/core/pages/tenant-ms-graph-edit-page/tenant-ms-graph-edit-page.component';
import { TenantDescriptionFormComponent } from 'app/modules/core/components/tenant-description-form/tenant-description-form.component';
import { TenantTagsComponent } from 'app/modules/core/components/tenant-tags/tenant-tags.component';
import { TenantEmailsListPageComponent } from 'app/modules/core/pages/tenants-emails-list-page/tenant-email-list-page.component';
import { TenantMsGraphEditFormComponent } from 'app/modules/core/components/tenant-ms-graph-edit-form/tenant-ms-graph-edit-form.component';
import { TenantFoldersComponent } from 'app/modules/core/components/tenant-folders/tenant-folders.component';
import { TenantTeamsComponent } from 'app/modules/core/components/tenant-teams/tenant-teams.component';
import { TenantDepartmentsComponent } from 'app/modules/core/components/tenant-departments/tenant-departments.component';
import { TenantChecklistPageComponent } from 'app/modules/core/pages/tenant-checklist-page/tenant-checklist-page.component';
import { TenantEmailTemplateComponent } from 'app/modules/core/components/tenant-email-template/tenant-email-template.component';
const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'unathorized/maps/:tenant',
    component: AuthlayoutComponent,
  },
  {
    path: '',
    component: AuthlayoutComponent,
    children: [
      {
        path: 'tenantIdDeepLinkError/:deepTenantId/:remainingPath',
        component: PagenotfoundComponent,
      },
    ],
  },
  {
    path: '',
    component: AuthlayoutComponent,
    children: [
      {
        path: 'signin',
        component: SigninComponent,
      },
      {
        path: 'signin/:error',
        component: SigninComponent,
      },
      {
        path: 'forgotpassword',
        component: ForgetpasswordComponent,
      },
      {
        path: 'resetpassword',
        component: ResetpasswordComponent,
      },
      {
        path: 'active-tenant-page',
        component: ActiveTenantPageComponent,
      },
      {
        path: 'office365auth',
        component: Office365authComponent,
      },
    ],
  },
  {
    path: '',
    component: ApphomelayoutComponent,
    canActivateChild: [AuthGuard],

    children: [
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'home',
        component: HomepageComponent,
        canActivate: [AuthGuard],
        // Empty trail -> renders the home crumb only and clears any prior chain.
        data: { breadcrumb: [] },
      },
      {
        path: 'tenants',
        component: TenantsPageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.PartnerManager],
          breadcrumb: [
            { labelKey: 'admin' },
            { labelKey: 'tenants', link: '/tenants' },
          ],
          breadcrumbConfig: { showSearchBar: true },
        },
      },
      {
        path: 'users',
        component: UsersListPageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin] },
      },
      {
        path: 'notifications',
        component: NotificationsListComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [
            UserRoles.Superadmin,
            UserRoles.TenantAdmin,
            UserRoles.User,
          ],
        },
      },
      {
        path: 'admin/documents/new',
        component: DocumentPostComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [
            UserRoles.Superadmin,
            UserRoles.TenantAdmin,
            UserRoles.User,
          ],
          feature: TenantFeatures.Documents,
        },
      },

      {
        path: 'admin/documents/documenttypes',
        component: DocumenttypePageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin] },
      },
      {
        path: 'admin/clients/:type/contact/:id',
        component: ContactsCreatePageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin] },
      },
      // {
      //   path: 'admin/clients/:type/location/:id',
      //   component: LocationsCreatePageComponent,
      //   canActivate: [AuthGuard],
      //   data: { authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin] },
      // },
      {
        path: 'admin/clients/locations/:id',
        component: AdminLocationsPageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin] },
      },
      {
        path: 'admin/clients/contacts/:id',
        component: AdminContactsPageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin] },
      },
      {
        path: 'admin/documents',
        component: AdminDocumentPageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin],
          feature: TenantFeatures.Documents,
        },
      },
      {
        path: 'admin/documenttype/new',
        component: DocumenttypePostComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin],
          feature: TenantFeatures.Documents,
        },
      },
      {
        path: 'admin/documents/edit/documenttype/:id',
        component: DocumenttypeEditpageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin],
          feature: TenantFeatures.Documents,
        },
      },
      {
        path: 'admin/documents/edit/:id',
        component: DocumentEditpageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin],
          feature: TenantFeatures.Documents,
        },
      },
      {
        path: 'admin/clients',
        component: AdminCompaniesPageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin],
        },
      },
      // {
      //   path: 'admin/clients/:id',
      //   component: ClientsCreatePageComponent,
      //   canActivate: [AuthGuard],
      //   data: {
      //     authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin],
      //     feature: TenantFeatures.Maps,
      //   },
      // },
      {
        path: 'documents/:id',
        component: DocumenttypeFromSideMenuComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.User, UserRoles.TenantAdmin],
          feature: TenantFeatures.Documents,
        },
      },
    ],
  },
  {
    path: '',
    component: ApphomelayoutComponent,
    canActivateChild: [AuthGuard],

    children: [
      {
        path: 'tenants/:id',
        component: TenantsCreatePageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.PartnerManager],
          breadcrumb: [
            { labelKey: 'admin' },
            { labelKey: 'tenants', link: '/tenants' },
            { dynamic: 'tenantName' },
          ],
        },
      },
      {
        path: 'tenants/description/:id',
        component: TenantDescriptionFormComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/info/:id',
        component: TenantInfoPageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/tags/:id',
        component: TenantTagsComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/folders/:id',
        component: TenantFoldersComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/teams/:id',
        component: TenantTeamsComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/departments/:id',
        component: TenantDepartmentsComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/checklists/:id',
        component: TenantChecklistPageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/html/:id',
        component: TenantEdithtmlPageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/emails/new/:tenantId',
        component: TenantMsGraphEditPageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.PartnerManager],
        },
      },
      {
        path: 'tenants/emails/:id',
        component: TenantEmailsListPageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'tenants/:tenantId/emails/:id',
        component: TenantMsGraphEditPageComponent,
        canActivate: [AuthGuard],
        data: {
          authorize: [UserRoles.Superadmin, UserRoles.PartnerManager],
        },
      },

      {
        path: 'users/:id',
        component: UsersCreatePageComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.TenantAdmin] },
      },
      {
        path: 'tenants/emailtemplate/:id',
        component: TenantEmailTemplateComponent,
        canActivate: [AuthGuard],
        data: { authorize: [UserRoles.Superadmin, UserRoles.PartnerManager] },
      },
      {
        path: 'profile/edit',
        component: ProfileEditComponent,
      },
    ],
  },
  { path: 'unauthorized', component: PagenotauthorizedComponent },
  { path: 'pagenotfound', component: PagenotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
